var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRyde = function SvgRyde(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 220,
    height: 59,
    fill: "none",
    viewBox: "0 0 220 59"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M47.2 58.6H35.5l-9.4-23H10.5v23H0V0h26.9c3.8 0 7.2.8 10.1 2.5 6 3.5 9 8.7 9 15.5 0 6.9-3.1 12.1-9.4 15.6l10.6 25ZM35.5 17.9c0-2.3-.8-4.1-2.3-5.4-1.5-1.3-3.6-2-6.1-2H10.5v14.6h16.6c2.6 0 4.6-.7 6.1-2 1.6-1.3 2.3-3 2.3-5.2ZM163 29.2c0 12-4.7 20.6-14.2 25.9-4.3 2.3-8.9 3.5-13.8 3.5h-18.9V0H135c5 0 9.7 1.3 14 3.8 9.3 5.3 14 13.8 14 25.4Zm-10.5 0c0-7.8-2.9-13.2-8.7-16.4-2.7-1.5-5.6-2.3-8.8-2.3h-8.2v37.6h8.2c2.9 0 5.7-.8 8.4-2.3 6-3.2 9.1-8.8 9.1-16.6ZM220 58.6h-43.7V0H219v10.5h-32.1V23h17.5v10.7h-17.5v14.4H220v10.5ZM103.1 0H90.7l-9.6 25.4L70.4 0H57.3l18 39.2-8.1 19.4h13.2L103.1 0Z"
  })));
};
export default SvgRyde;